<template>
  <div
    class="form-input-button"
    :class="{'is-invalid': state === false}"
  >
    <BInputGroup>
      <BFormInput
        :value="value"
        :state="state"
        :autocomplete="$attrs.type === 'password' ? 'off' : undefined"
        :aria-label="buttonValue"
        v-bind="$attrs"
        v-on="listeners"
      />

      <template v-slot:append>
        <button
          :disabled="$attrs.disabled"
          @click="clickButton"
          :class="{
            'btn-dark': state !== false,
            'btn-danger': state === false
          }"
          type="button"
          class="btn"
        >
          {{ buttonValue }}
        </button>
      </template>
    </BInputGroup>

    <div
      v-if="errorMessage"
      tabindex="-1"
      role="alert"
      class="invalid-feedback"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import {BInputGroup} from 'bootstrap-vue/src/components/input-group/input-group'
import {BFormInput} from 'bootstrap-vue/src/components/form-input/form-input'

export default {
  components: {
    BInputGroup,
    BFormInput,
  },
  inheritAttrs: false,
  props: {
    /**
     * The current value of the textarea. Result will always be a string.
     */
    value: {
      type: [String, Number],
      default: undefined,
    },

    /**
     * Controls the validation state appearance of the component. 'true' for valid, 'false' or 'null' for no validation state
     */
    isInvalid: {
      type: Boolean,
      default: false,
    },

    /**
     * Text to show when the form group has an invalid state
     */
    errorMessage: {
      type: String,
      default: undefined,
    },

    /**
     * The current value of the button.
     */
    buttonValue: {
      type: String,
      required: true,
    },
  },

  computed: {
    state () {
      if (this.errorMessage && this.errorMessage.length > 0) {
        return false
      } else if (this.isInvalid) {
        return false
      } else {
        return null
      }
    },

    listeners () {
      const {click, ...listeners} = this.$listeners
      return listeners
    },
  },

  methods: {
    clickButton (e) {
      /**
       * Event triggered by user interaction. Emitted after the button is clicked
       */
      this.$emit('click', e)
    },
  },
}
</script>

<style lang="scss">


.form-input-button {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;

  &:focus,
  &.focus {
    outline: $cyan-500 solid 2px;
  }

  .form-control {
    border-right: none !important;
    flex-grow: 1 !important;

    &:disabled {
      pointer-events: none;
    }

    &:focus {
      border-width: 1px;
      padding: $input-padding-y $input-padding-x;

      &:not(:disabled) {
        border-color: $gray-900 !important;
      }

      &:disabled {
        border-color: $gray-200 !important;
      }
    }
  }

  .btn {
    border-top-right-radius: $btn-border-radius;
    border-bottom-right-radius: $btn-border-radius;

    // Disabled comes first so active can properly restyle
    &.disabled,
    &:disabled {
      background-color: $gray-300;
      border-color: $gray-300;
      cursor: default;
    }
  }

  .invalid-feedback {
    display: block;
  }
}
</style>
